<template>
  <div class="ai-page-container">
    <el-table
      style="width: 100%"
      type="border"
      :data="listData"
      v-loading="tableLoading"
    >
      <el-table-column prop="channelId" label="通道编号"> </el-table-column>
      <el-table-column prop="deviceId" label="设备编号"> </el-table-column>
      <el-table-column prop="name" label="通道名称"> </el-table-column>
      <el-table-column prop="manufacture" label="厂家"> </el-table-column>
      <el-table-column prop="PTZTypeText" label="云台类型"> </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status" type="success">在线</el-tag>
          <el-tag v-else type="danger">离线</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="clickToWatch(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageParams.num"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageParams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listTotal"
      >
      </el-pagination>
    </div>

    <el-dialog
      :title="dialogName"
      width="60%"
      :visible.sync="dialogVisible"
      :before-close="beforeDialogClose"
    >
      <div class="cnt-txt">数量：{{ dialogCnt }}</div>
      <div v-if="wsErrorTips" class="ws-error-tips">{{ wsErrorTips }}</div>
      <img alt ref="imgElm" class="video-feed" />
      <span slot="footer">
        <el-button @click="beforeDialogClose">取 消</el-button>
        <el-button type="primary" @click="beforeDialogClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wsBaseUrl: 'ws://10.96.128.187:8000/ws?rtsp_url=', // k8s: 10.96.128.187:8000, hwx-local: 10.208.59.244
      deviceId: '34020000001110000006',
      pageParams: {
        num: 1,
        size: 10
      },
      listTotal: 0,
      listData: [],
      dialogVisible: false,
      playUrl: '',
      ws: undefined,
      dialogName: '',
      dialogCnt: 0,
      wsErrorTips: '',
      tableLoading: false,
      imgElm: undefined,
      testBaseUrl: 'http://10.96.128.187:8000',
      cntTimer: undefined
    };
  },
  mounted() {
    this.getChannels();
  },
  methods: {
    beforeDialogClose() {
      if (this.ws) {
        this.ws.close();
        this.ws = undefined;
      }
      this.dialogVisible = false;
      setTimeout(() => {
        this.dialogName = '';
        this.playUrl = '';
        this.dialogCnt = 0;
        this.wsErrorTips = '';
        this.imgElm.src = '';
        clearInterval(this.cntTimer);
        this.cntTimer = undefined;
      }, 200);
    },
    clickToWatch(data) {
      console.log('clickToWatch data: ', data);
      const that = this;
      const videoId = data.id;
      this.tableLoading = true;
      this.dialogName = data.name;
      this.getPlayUrl(data.deviceId, data.channelId)
        .then((res) => {
          const data = res.data.data;
          this.playUrl = data.ts;
          this.dialogVisible = true;
          this.tableLoading = false;
          setTimeout(() => {
            // that.processAiSocket();
            that.processPicStream(this.playUrl, videoId);
            that.cntTimer = setInterval(() => {
              that.getCowCnt(videoId);
            }, 1000);
          }, 100);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    getCowCnt(videoId) {
      if (!videoId) return;
      const url = '/ai/getCowCnt';
      this.$axios({
        url: url,
        params: {
          id: videoId
        },
        withCredentials: true
      }).then((res) => {
        const cnt = res.data.data.cnt || 0;
        this.dialogCnt = cnt;
      });
    },
    processPicStream(playUrl, videoId) {
      if (!playUrl || !videoId) return;
      const picStreamUrl =
        this.testBaseUrl + '/getFrame?url=' + playUrl + '&id=' + videoId;
      this.imgElm = this.$refs.imgElm;
      console.log('processPicStream: ', picStreamUrl);
      this.imgElm.src = picStreamUrl;
    },
    processAiSocket() {
      if (!this.playUrl) return;
      console.log('new WebSocket');
      const that = this;
      this.imgElm = this.$refs.imgElm;
      this.ws = new WebSocket(this.wsBaseUrl + this.playUrl);
      // 当连接打开时触发
      this.ws.onopen = function (event) {
        console.log('WebSocket is connected.');
      };
      // 监听从服务器返回的消息
      this.ws.onmessage = (event) => {
        const date = new Date();
        const data = JSON.parse(event.data);
        console.log(date.toLocaleTimeString() + ': ' + data.image);
        that.$nextTick(() => {
          that.imgElm.src = data.image || '';
          that.dialogCnt = data.cnt || 0;
          if (data.code != 1000) {
            that.wsErrorTips = `${data.msg} (${data.code})`;
          }
        });
      };
      // 监听WebSocket错误事件
      this.ws.onerror = function (error) {
        console.log('WebSocket Error: ' + error);
        that.wsErrorTips = 'Error Connection To ' + error.target.url;
      };
      // 监听WebSocket连接关闭事件
      this.ws.onclose = function (event) {
        console.log('WebSocket is closed now.');
      };
    },
    handleSizeChange(val) {
      this.pageParams.size = val;
      this.getChannels();
    },
    handleCurrentChange(val) {
      this.pageParams.num = val;
      this.getChannels();
    },
    getChannels() {
      const that = this;
      this.$axios({
        method: 'get',
        url: `/api/device/query/devices/${this.deviceId}/channels`,
        params: {
          page: this.pageParams.num,
          count: this.pageParams.size,
          query: '',
          online: '',
          channelType: '',
          catalogUnderDevice: ''
        }
      }).then((res) => {
        const data = res.data.data;
        that.listTotal = data.total || 0;
        that.listData = data.list || [];
      });
    },
    getPlayUrl(deviceId, channelId) {
      return this.$axios({
        method: 'get',
        url: `/api/play/start/${deviceId}/${channelId}`
      });
    }
  }
};
</script>

<style scoped>
.ai-page-container {
  width: 100%;
  padding: 0;
}

.pagination-wrapper {
  display: flex;
  justify-content: right;
  margin-top: 12px;
}

.video-feed {
  width: 100%;
  min-height: 400px;
  margin-top: 24px;
}

.cnt-txt {
  display: flex;
  color: #d7000f;
  font-size: 24px;
}

.image-loading {
  margin-top: 24px;
  min-height: 400px;
  background: #000;
}

.ws-error-tips {
  margin-top: 24px;
  display: flex;
  color: rgba(0, 0, 0, 0.65);
}
</style>


// WEBPACK FOOTER //
// src/components/AiPage.vue